import { Link } from 'react-router-dom';
import './styles.scss';

const ProductCatalogBox = ({ title, image, description, file }) => {
    return (
        <div className="box product-box">
            <h3>{title}</h3>
            <div className="product-catalog">
                <img src={image} alt={title} />
                <p className="body1 product-catalog__text">{description}</p>
                <div className="product-catalog__buttons">
                    <Link
                        to={file}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="button button-eye  has-children"
                    >
                        <div></div>
                        <div>VIEW CATALOG</div>
                    </Link>
                    <Link
                        to={file}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="button download-button has-children"
                        download
                    >
                        <div></div>
                        <div>DOWNLOAD</div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProductCatalogBox;
